<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
    (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
    [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
    [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

<c-modal [visible]="bShowResolution" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="resolutionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Enter the resolution</h5>
            <button (click)="closeResolutionModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
            <c-input-group class="mb-3 has-validation">
                <span cInputGroupText>
                    Resolution
                </span>
                <input [valid]="bValidResolution" cFormControl formControlName="resolutionControl" id="RejectReason"
                    type="text" />
                <c-form-feedback [valid]="bValidResolution">{{ifResolutionValid()}}</c-form-feedback>
            </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeResolutionModal()">
                Cancel
            </button>
            <button cButton color="primary" (click)="processResolution()">Resolve</button>
        </c-modal-footer>
    </form>
</c-modal>

<div *ngIf="true">

    <div *ngIf="!showUserForm">
        <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
            <c-container fluid>
                <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="getServices()">
                    <c-row [gutter]="{gy: 1}">
                        <c-col md="auto">
                            <c-input-group class="has-validation">
                                <span cInputGroupText>
                                    Complaint Type
                                </span>
                                <select cSelect id="serviceType" name="serviceType"
                                    formControlName="searchServiceTypeControl" (change)="onSelectChange()">
                                    <option selected value="All">All</option>
                                    <option *ngFor="let serviceType of serviceTypes" [value]="serviceType.value">
                                        {{serviceType.key}}
                                    </option>
                                </select>

                            </c-input-group>
                        </c-col>
                    </c-row>
                    <c-row [gutter]="{gy: 1}">
                        <c-col lg="5">
                            <c-date-range-picker [startDate]="startDate" [endDate]="endDate"
                                (startDateChange)="onStartDateChane($event)"
                                (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
                        </c-col>
                        <c-col md="auto">
                            <c-input-group class="has-validation">
                                <span cInputGroupText>
                                    Ticket Type
                                </span>
                                <select cSelect id="ticketType" name="ticketType"
                                    formControlName="searchTicketTypeControl" (change)="onSelectChange()">
                                    <option>Open Tickets</option>
                                    <option>Closed Tickets</option>
                                    <option selected>All Tickets</option>
                                </select>
                            </c-input-group>
                        </c-col>
                        <c-col md="auto">
                            <button cButton type="submit">
                                Search
                            </button>
                        </c-col>
                    </c-row>
                </form>
            </c-container>
        </c-navbar>

        <c-smart-table *ngIf="!showUserForm" [columnSorter]="true" [columns]="columns" [columnFilter]="true"
            [itemsPerPageSelect]="true" [itemsPerPage]="15" [items]="serviceData" [tableBodyProps]="{ align: 'middle' }"
            [tableProps]="{ hover: true, striped: true, responsive: true }" clickableRows header pagination
            (rowClick)="onRowClick($event)">
            <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
                <td>
                    <ng-container [ngSwitch]="columnName">
                        <ng-container *ngSwitchCase="'requestedOn'">
                            {{(getDisplayDate(item))}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'resolvedOn'">
                            {{(getResolutionDate(item))}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'isOpen'">
                            <c-badge [color]="getStatusBadge(item)">
                                {{(getStatus(item))}}
                            </c-badge>
                        </ng-container>
                        <ng-container *ngSwitchCase="'raisedBy'">
                            <button cButton style="text-wrap-mode: nowrap;" size="sm" *ngIf="showResolveButton(item)"
                                (click)="updateStatus(item)">{{getActionButtonText(item)}}</button>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{tdContent}}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-template>
        </c-smart-table>
    </div>
    <div *ngIf="showUserForm" style="margin-top:20px;background-color: #fff;padding: 32px;">
        <div class="section-title">Complain Details</div>

        <form cForm [formGroup]="userForm" class="needs-validation" [gutter]="3" novalidate>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputComplainNo">Complain No</label>
                    <input readonly cFormControl id="inputComplainNo" type="text" formControlName="complainNo" />
                </div>
                <div class="col-6">
                    <label cLabel for="ddlStatus">Status</label>
                    <select cSelect id="ddlStatus" name="status" formControlName="status">

                        <option value="Open">Open</option>
                        <option value="Resolved">Resolved</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputCIF">CIF</label>
                    <input readonly cFormControl id="inputCIF" type="text" formControlName="cif" />
                </div>
                <div class="col-6">
                    <label cLabel for="inputCustomerName">Customer Name</label>
                    <input readonly cFormControl id="inputCustomerName" type="email" formControlName="customerName" />
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-6">
                    <label cLabel for="inputCategory">Category</label>
                    <input readonly cFormControl id="inputCategory" type="tel" formControlName="category" />
                </div>

            </div>
            <div class="row pt-2">
                <div class="col-12">
                    <label cLabel for="inputRemarks">Customer Remarks</label>
                    <textarea readonly cFormControl id="inputRemarks" rows="4" formControlName="remarks"></textarea>
                </div>
                <div class="col-12 pt-2">
                    <label cLabel for="inputInternalRemarks">Internal Remarks</label>
                    <textarea cFormControl id="inputInternalRemarks" rows="4" formControlName="internalRemarks"></textarea>
                </div>                
                <div class="col-12">
                    <label cLabel for="inputComplaintType">Resolution Remarks</label>
                    <textarea cFormControl id="inputComplaintType" rows="4" formControlName="complaintType"></textarea>
                </div>
                <div class="col-12 pt-2">
                    <div cFormCheck>
                        <input cFormCheckInput id="sendRemarksToCustomer" type="checkbox" formControlName="sendRemarksToCustomer" />
                        <label cFormCheckLabel for="sendRemarksToCustomer">Send these Remarks to Customer</label>
                    </div>

                </div>
            </div>

            <!-- Section: Documents Uploads -->
            <!-- Generic block to render document sections -->
            <ng-container *ngFor="let docGroup of documentGroups">
                <div class="col-12" *ngIf="docGroup.docs.length">
                    <h6 style="padding: 15px 0;">{{ docGroup.label }}</h6>
                    <div class="row">
                        <div class="col-4" *ngFor="let doc of docGroup.docs">
                            <button (click)="downloadDocument(doc)"
                                class="btn btn-light d-flex align-items-center justify-content-between w-100 mb-2">
                                <div class="d-flex align-items-center gap-2">
                                    <i [ngClass]="getFileIconClass(doc.documentName)" class="me-2"></i>
                                    <span>{{ truncateFileName(doc.documentName, 20, 15) }}</span>
                                </div>
                                <i class="doc-arrow"></i> <!-- Font Awesome arrow icon -->
                            </button>
                        </div>
                    </div>
                    <hr>
                </div>
            </ng-container>


            <div class="row" style="margin-top: 32px;padding-bottom:32px;">
                <div class="col-12 d-flex gap-24" style="justify-content: flex-end;">
                    <button cButton color="light" size="lg" type="button" (click)="resetForm()">
                        Cancel
                    </button>
                    <button cButton color="primary" size="lg" type="submit" *ngIf="currentComplaintIsOpen"
                        [disabled]="!canUpdateForm()"
                        (click)="onUserFormSaveClick();">
                        Update
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>